<template>
  <div class="mt-8" id="video-library" v-if="showEmptyStates || (videos && videos.length)">
    <div class="flex items-center justify-between mb-5">
      <h2 class="font-bold ds-text-3xl text-gray-1000 my-0" id="videoLabel">Video</h2>
    </div>

    <event-beacon-banner></event-beacon-banner>
    <Spinner v-if="!isLoaded" />

    <EmptyState v-else-if="!videos.length && !hasPrivateVideos" :athlete="athlete" />
    <div
      v-else-if="isLoggedOut && hasPrivateVideos"
      class="flex flex-col w-full p-2 p-4 px-6 mb-8 font-medium text-gray-900 bg-gray-200 border border-blue-300 border-solid rounded ds-text-sm md:w-auto md:ml-auto"
    >
      <span>
        This athlete has chosen to make their videos private.
        <a
          href="/login"
          class="font-semibold text-blue-300 hover:text-blue-400"
          style="display: inline;"
        >Log in</a>
        to see {{ firstName }}'s full profile and videos.
      </span>
    </div>
    <template v-else>
      <AthleteVideoSet displayMode="grid" :videos="videos" class="h-auto mb-8" />
    </template>
  </div>
</template>

<script>
import AthleteVideoSet from "./VideoSet.vue";
import EmptyState from "./EmptyState.vue";
import IconSwitcher from "@/components/IconSwitcher";
import Spinner from "@/components/Spinner";
import EventBeaconBanner from "@/components/AthleteProfile/EventBeaconBanner";

import range from "lodash/range";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    AthleteVideoSet,
    EmptyState,
    IconSwitcher,
    Spinner,
    EventBeaconBanner
  },

  props: {
    userId: { required: false, default: null },
    showEmptyStates: { required: false, default: true, type: Boolean }
  },

  mounted() {
    if (!this.hasPrivateVideos && !this.isLoggedOut && this.userId) {
      this.$store.dispatch("athleteProfile/fetchVideos", this.userId);
    }
  },

  data() {
    return {
      displayMode: "list",
      isPublic: true
    };
  },
  computed: {
    ...mapState({
      firstName: state => state.athleteProfile.user.firstName,
      hasPrivateVideos: state => state.athleteProfile.user.hasPrivateVideos
    }),
    ...mapGetters({
      videos: "athleteProfile/videos",
      athlete: "athleteProfile/athlete",
      isLoggedOut: "userData/isLoggedOut"
    }),
    isLoaded() {
      return !!this.videos;
    }
  }
};
</script>

<style scoped>
</style>
